module.exports = __webpack_public_path__ + "static/404-09d4ceaa6ccfa18025d93aa8b3cea378.svg";